import {fabric} from 'fabric';
import {cloneControl} from '~/common/canvas/controls/clone';
import {removeControl} from '~/common/canvas/controls/remove';
import {rotationControl} from '~/common/canvas/controls/rotation';
import * as colors from '~libSass/base/_exports.sass';
import {DEFAULT_CANVAS_HEIGHT, DEFAULT_CANVAS_WIDTH} from './constants';
import './Canvas.sass';
import './customs';

const controlsVisibility = {
  tl: true, // top-left
  mt: false, // middle-top
  tr: true, // top-right
  ml: false, // middle-left
  mr: false, // middle-right
  bl: true, // bottom-left
  mb: false, // middle-bottom
  br: true, // bottom-right
  mtr: true, // rotate icon
};

fabric.Textbox.prototype.setControlsVisibility(controlsVisibility);

fabric.Textbox.prototype.set({
  hoverCursor: 'pointer',
  moveCursor: 'default',
  touchCornerSize: 40,
  editingBorderColor: colors.tanzanite,
});

fabric.Image.prototype.set({
  hoverCursor: 'pointer',
  moveCursor: 'default',
  touchCornerSize: 40,
  editingBorderColor: colors.tanzanite,
});

fabric.Object.prototype.controls.tl.offsetX = -1;
fabric.Object.prototype.controls.tl.offsetY = -1;
fabric.Object.prototype.controls.tr.offsetX = 1;
fabric.Object.prototype.controls.tr.offsetY = -1;
fabric.Object.prototype.controls.bl.offsetX = -1;
fabric.Object.prototype.controls.bl.offsetY = 1;
fabric.Object.prototype.controls.br.offsetX = 1;
fabric.Object.prototype.controls.br.offsetY = 1;

fabric.Textbox.prototype.controls.mtr = rotationControl();
fabric.Textbox.prototype.controls.remove = removeControl();
fabric.Textbox.prototype.controls.clone = cloneControl();

fabric.Image.prototype.controls.mtr = rotationControl();
fabric.Image.prototype.controls.remove = removeControl({offsetX: 0});

fabric.Object.prototype.set({
  cornerSize: 9,
  borderColor: colors.tanzanite,
  transparentCorners: false,
  cornerStrokeColor: colors.tanzanite,
  cornerColor: colors.white,
  objectCaching: true,
});

const {_renderBackgroundOrOverlay: renderBackgroundOrOverlay, __setBgOverlay: setBgOverlay} =
  fabric.StaticCanvas.prototype;
fabric.StaticCanvas.prototype.__setBgOverlay = function (property, value, loaded, callback) {
  if (property === 'backgroundImage') {
    const {_crossOrigin, ...backgroundImage} = value;
    backgroundImage.crossOrigin = 'anonymous';
    return setBgOverlay.call(this, property, backgroundImage, loaded, callback);
  }

  setBgOverlay.call(this, property, value, loaded, callback);
};
fabric.StaticCanvas.prototype._renderBackgroundOrOverlay = function (ctx, property) {
  const isGif = this.backgroundImage?.src?.endsWith('.gif');
  const mp4 = this.backgroundImage?.src?.endsWith('.mp4');
  if (property !== 'background' || !isGif) {
    if (property === 'background' && this.backgroundImage && !mp4) {
      this.backgroundImage.scaleToWidth(this.backgroundImage?.width || DEFAULT_CANVAS_WIDTH);
      this.backgroundImage.scaleToHeight(this.backgroundImage?.height || DEFAULT_CANVAS_HEIGHT);
    }
    return renderBackgroundOrOverlay.call(this, ctx, property);
  }

  if (this.backgroundImage) {
    const {originalUrl, _originalElement} = this.backgroundImage;

    ctx.canvas.style.backgroundImage = `url(${originalUrl || _originalElement.src})`;
    ctx.canvas.style.backgroundSize = '100%';
    ctx.canvas.style.backgroundRepeat = 'no-repeat';
  }
};

// https://github.com/fabricjs/fabric.js/issues/5903#issuecomment-699011321
const defaultOnTouchStartHandler = fabric.Canvas.prototype._onTouchStart;
fabric.util.object.extend(fabric.Canvas.prototype, {
  // biome-ignore lint/style/useNamingConvention: underscore
  _onTouchStart: function _onTouchStart(e) {
    const target = this.findTarget(e);
    // target is undefined when clicked on background
    // target.type is image = uYOImage, so when there is a uYOImage and a uploaded image
    // allow the canvas to scroll
    if (this.allowTouchScrolling && (!target || target.type === 'image') && !this.isDrawingMode) {
      return;
    }

    defaultOnTouchStartHandler.call(this, e);
  },
});

export default fabric;
